import { useI18n } from 'vue-i18n';

export const createLocaleFormatters = (locale = 'it') => ({
    date(value, options = {}) {
        if (value === null || value === undefined || value === '') return '';
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return '';

        return new Intl.DateTimeFormat(locale, options).format(date);
    },
    number(value, options = {}) {
        if (value === null || value === undefined || value === '') return '';
        const number = Number(value);
        if (!Number.isFinite(number)) return '';

        return new Intl.NumberFormat(locale, options).format(number);
    },
    collator(options = {}) {
        return new Intl.Collator(locale, options);
    },
});

export function useLocaleFormatting() {
    const { locale } = useI18n({ useScope: 'global' });

    return {
        formatDate: (value, options) => createLocaleFormatters(locale.value).date(value, options),
        formatNumber: (value, options) => createLocaleFormatters(locale.value).number(value, options),
        createCollator: (options) => createLocaleFormatters(locale.value).collator(options),
    };
}
